module.exports = __webpack_public_path__ + "img/56.ec9dc3b1.svg";